export default () => ({
  cachedAuthorDetails: {},
  generalPosts: [],
  followingPosts: [],
})
